import { ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const aboutAutocomplete: ThemedFunctor = ({ $isMobile }) => css`
  width: ${$isMobile ? '100%' : '250px'};
`;

/* Fills the (non scrolling) modal body: only the thumbnails list scrolls, the toolbar stays visible */
export const mobileBase: ThemedFunctor = ({ theme }) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.remSize[200]};
  height: 100%;
  min-height: 0;
  /* The modal body is not padded: no bottom padding, so the list scrolls right up to the footer */
  padding: ${theme.remSize[200]} ${theme.remSize[200]} 0;
`;

export const mobileToolbar: ThemedFunctor = ({ theme }) => css`
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  gap: ${theme.remSize[150]};
`;

export const mobileThumbnails = () => css`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const mobileDetail: ThemedFunctor = ({ theme }) => css`
  ${mobileBase({ theme })}
  overflow-y: auto;
  padding-bottom: ${theme.remSize[200]};
`;

export const empty: ThemedFunctor = ({ theme, $isMobile }) => css`
  ${$isMobile && `
    padding: ${theme.remSize[200]};
  `}
`;

export const mobileBulkActions: ThemedFunctor = ({ theme }) => css`
  display: flex;
  gap: ${theme.remSize[100]};

  & > * {
    flex: 1;
  }
`;

export const mobileDetailHeader: ThemedFunctor = ({ theme }) => css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.remSize[100]};
`;

export const mobileDetailImage: ThemedFunctor = ({ theme, $selected }) => css`
  position: relative;
  width: 100%;
  aspect-ratio: 3 / 2;
  overflow: hidden;
  user-select: none;
  background-color: ${theme.color.background.neutral.default.high};

  ${$selected && `
    outline: 2px solid ${theme.color.border.primary.default.high};
  `}

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const mobileDetailBottomBar: ThemedFunctor = ({ theme }) => css`
  position: absolute;
  left: ${theme.remSize[100]};
  right: ${theme.remSize[100]};
  bottom: ${theme.remSize[100]};
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: ${theme.remSize[100]};
`;

export const mobileDetailFileName = () => css`
  flex: 1 1 auto;
  display: flex;
  justify-content: flex-end;
  min-width: 0;

  /* Badge does not truncate its label: constrain it and ellipsize the inner text */
  & > * {
    max-width: 100%;
    min-width: 0;
  }

  & > * > span {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
